import { Link, Outlet, useLocation } from 'react-router-dom';

export default function ProductCertification() {
  const location = useLocation();
  const isMainPage = location.pathname === '/product-certification' || location.pathname === '/product-certification/';

  const links = [
    // { name: 'Հայտի ձև 1', path: '/product-certification/form-1' },
    // { name: 'Հայտի ձև 2', path: '/product-certification/form-2' },
    // { name: 'Սխեմա 1', path: '/product-certification/scheme-1' },
    { name: 'Նորմատիվ փաստաթղթեր', path: '/product-certification/regulatory-documents'},
    { name: 'Գնացուցակ', path: '/product-certification/price-list' },
    { name: 'Բողոքներ և գանգատներ', path: '/product-certification/abuse' },
    // { name: 'Քաղաքականությունը և նպատակները', path: '/product-certification/policy' },
    // { name: 'ՍՄ կառուցվածք', path: '/product-certification/structure' },
    // { name: 'Տեղեկատվություն', path: '/product-certification/info' },
    // { name: 'Կառավարման համակարգի փաստ ցանկ', path: '/product-certification/management-system' },
  ];

  return (
    <main className="min-h-screen pt-24 pb-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <aside className="lg:w-1/4">
            <div className="bg-white rounded-xl shadow-md p-6 sticky top-24">
              <nav className="flex flex-col space-y-2">
                <Link 
                  to="/product-certification/" 
                  className={`px-4 py-2 rounded-lg transition-colors ${isMainPage ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-50'}`}
                >
                  Որակի Համակարգ
                </Link>
                {links.map((link) => (
                  <Link 
                    key={link.path}
                    to={link.path}
                    className={`px-4 py-2 rounded-lg transition-colors ${location.pathname === link.path ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-50'}`}
                  >
                    {link.name}
                  </Link>
                ))}
              </nav>
            </div>
          </aside>

          {/* Content */}
          <div className="lg:w-3/4 bg-white rounded-xl shadow-md p-8">
            {isMainPage ? (
              <div className="prose max-w-none text-gray-700">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Քաղաքականություն</h2>
                <br/><br/>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Անկողմնակլություն</h2>
                <br/><br/>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Գաղտնիություն</h2>
                <br/><br/>
              </div>
            ) : (
              <Outlet />
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
